import type { AutosuggestProps } from 'folio-common-components';
import * as React from 'react';
import { useState } from 'react';
import type { CompanySearchItem } from '../../state/companySearch';
import { ControlledCompanyInput } from './ControlledCompanyInput';

interface Props {
  selected?: Pick<CompanySearchItem, 'orgId' | 'name'>;
  onSelect: (c: CompanySearchItem | undefined) => void;
  renderSuggestion?: AutosuggestProps<any>['renderSuggestion'];
}

export const CompanyInput: React.FC<Props> = props => {
  const { onSelect, selected, renderSuggestion } = props;
  const [value, setValue] = useState('');

  return (
    <ControlledCompanyInput
      value={value}
      onChange={v => {
        setValue(v ?? '');
      }}
      selected={selected}
      onSelect={onSelect}
      renderSuggestion={renderSuggestion}
    />
  );
};
